import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import LoginPage from "./pages/LoginPage";
import LandingPage from "./pages/LandingPage";

const MyRoutes = () => {
    const session = localStorage.getItem("session");

    return (
        <Router>
            {
                session
                    ? <LandingPage />
                    : <Routes>
                        <Route path="/login" element={<LoginPage />} />
                        <Route path="*" element={<Navigate to="/login" replace />} />
                    </Routes>
            }
        </Router>   
    );
};

export default MyRoutes;